// app-recreation-project/src/main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Inform the boot-debug script that React has started executing main.jsx
if (typeof window !== 'undefined' && window.__BPA_BOOT_DEBUG__) {
  console.log('[BOOT DEBUG] main.jsx is executing.');
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  // This should never happen in our app, but if it does, fail loudly.
  // eslint-disable-next-line no-console
  console.error('[BOOT DEBUG] No #root element found in index.html.');
} else {
  const root = createRoot(rootElement);

  try {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // Mark React as fully mounted for the boot-debug script
    if (typeof window !== 'undefined' && window.__BPA_BOOT_DEBUG__) {
      window.__BPA_BOOT_DEBUG__.markMounted();
    }

    console.log('[BOOT DEBUG] React root rendered successfully.');
  } catch (err) {
    // If React crashes during initial render, log and rethrow
    // eslint-disable-next-line no-console
    console.error('[BOOT DEBUG] Error during initial React render:', err);
    throw err;
  }
}